import React from "react"
import { Toaster as SonnerToaster, toast } from "sonner"

export { toast }

export function Toaster() {
  const [theme, setTheme] = React.useState<"light" | "dark">(() =>
    document.documentElement.dataset.theme === "dark" ? "dark" : "light",
  )

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      setTheme(document.documentElement.dataset.theme === "dark" ? "dark" : "light")
    })
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] })
    return () => observer.disconnect()
  }, [])

  return <SonnerToaster theme={theme} position="bottom-right" closeButton richColors />
}
